import { createTheme } from "@mui/material/styles";

const arcOrange = "#FFBA60";
export default createTheme({
  palette: {
    secondary: {
      main: `#bdbdbd`,
    },
    appBar: {
      main: "#001B42",
      color: "white",
      top: "black",
    },
    shellBar: "#33416d",
    appBg: "#e0e0e0",
  },
  typography: {
    button: {
      textTransform: "none",
      fontSize: "12px",
    },
  },
});
